// extracted by mini-css-extract-plugin
export var listItem = "messenger-tree-module--list-item--7d279";
export var textWrapper = "messenger-tree-module--text-wrapper--551fe";